import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepThreeExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepThreeExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.memoryStepThreeExtraCollections.data.memoryStepThreeExtraCollections,
  (collections = []) => collections
);
const getGroupLabel = createSelector(
  (state) =>
    state.memoryStepThreeExtraCollections.data.memoryStepThreeExtraGroupLabel,
  (groupLabel = '') => groupLabel
);
const getPageCount = createSelector(
  (state) => state.memoryStepThreeExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getGroupLabel,
  getHasLoaded,
  getPageCount,
};
